import React, { useEffect, useRef } from 'react';
import loaderWebm from '@lib/assets/images/loader-420.webm';
import loaderMp4 from '@lib/assets/images/loader-420.mp4';
import Logo from '@lib/assets/images/logo.svg?react';
import iOS from '@lib/utils/iOS';
import styles from './LogoLoader.module.scss';

const sources = [
  { src: loaderWebm, type: 'video/webm', key: 'webm' },
  { src: loaderMp4, type: 'video/mp4', key: 'mp4' },
];

export default function LogoLoader({
  setVisible,
}: {
  setVisible: (v: boolean) => void;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);

  const isIOS = iOS();

  useEffect(() => {
    if (!isIOS) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => setVisible(false), 2000);

    return () => window.clearTimeout(timeoutId);
  }, [isIOS, setVisible]);

  return (
    <div className={styles.loaderWrap}>
      {isIOS ? (
        <Logo className={styles.loaderLogo} />
      ) : (
        <video
          autoPlay
          className={styles.loaderVideo}
          controls={false}
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          muted
          onEnded={() => setVisible(false)}
          playsInline
          preload="auto"
          ref={videoRef}
        >
          {sources.map((source) => (
            <source key={source.key} src={source.src} type={source.type} />
          ))}
        </video>
      )}
    </div>
  );
}
